import * as React from 'react';
import clsx from 'clsx';
import { useState } from 'react';
import generateGuid from '../../../app/utils/generateGuid';

export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    hasError?: boolean;
    append?: React.ReactNode;
}

const FormFile = React.forwardRef<HTMLInputElement, FormInputProps>((
    {
        append,
        className,
        hasError,
        onChange,
        ...rest
    },
    ref
): React.ReactElement => {
    const [hasFocus, setFocus] = useState(false);
    const [id] = useState(generateGuid());

    return (
        <label
            htmlFor={id}
            className={clsx(
                'form-control-container',
                hasError && 'has-error',
                hasFocus && 'has-focus',
                className
            )}
        >
            <input
                id={id}
                ref={ref}
                type="file"
                className={clsx(
                    'form-control'
                )}
                onFocus={() => {
                    setFocus(true);
                }}
                onBlur={() => {
                    setFocus(false);
                }}
                onChange={onChange}
                {...rest}
            />
            {append && (
                <div
                    className="form-control-container-append"
                >
                    {append}
                </div>
            )}
        </label>
    );
});

FormFile.displayName = 'FormFile';

export default FormFile;
